<template>
  <el-container style="width: 100%;height: 100%;display: flex;flex-direction: column;">
    <el-row style="width: 100%;height: 100%;display: flex;flex-direction: row;">
      <el-aside style="height: 100%;width: 250px;margin-right: 1px;background-color: #ffffff;">
        <el-row class="doc-tree-top">
          <el-input style='width: 100%; border: none; outline: none' class="filter-search" placeholder="输入关键字搜索" prefix-icon="zy-icon-search" v-model="filterName"/>
        </el-row>
        <el-tree :data="treeData" :props="defaultProps" :filter-node-method="filterNode" node-key='id'
                 :default-expanded-keys="expandKeys" ref="tree" class="aside-tree" show-checkbox :default-checked-keys="checkedKey">
          <span slot-scope="{ node, data }">
            <i v-if="node.data.type === '1'" class="zy-icon-building"></i>
            <i v-if="node.data.type === '2'" class="zy-icon-commit"></i>
            <i v-if="node.data.type === '3'" class="zy-icon-sensor"></i>
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </el-aside>
      <el-main style="overflow-y: hidden;font-size: 14px;width: calc(100% - 251px);height: 100%;background-color: #ffffff;">
        <el-row class="tt-input" style="width: 100%;height: 48px;line-height: 48px;color: rgb(127, 127, 127);text-align: left;">
          <el-button class="search-btn-blue" style="margin-left: 16px;" @click="getChartData" type="primary" size="mini">开始分析</el-button>
        </el-row>
        <el-row style="background-color: #fff;width: 100%; height: 1px;"></el-row>
        <el-row v-if="isShow" style="overflow-y: auto;height: calc(100% - 49px);width: 100%;">
          <el-row style="height: calc(50% - 1px);width: 100%;">
            <el-row style="background-color: rgba(2, 124, 247, 0.8);width: 100%; height: 48px;">
              <span style="text-align: left;height: 48px;line-height: 48px;margin-left: 24px;color: rgb(247, 247, 247);display: flex;">近5日平均功率</span>
            </el-row>
            <el-col style="width: 100%;height: calc(100% - 48px);display: flex;">
              <el-col style="width: 65%;height: 100%;">
                <common-charts :init-options="initOptions" class="electric-parameter-charts"
                           :index="200" :key="timestamp" :options="curveData" autoresize :style="{'height': ((bgSize.height - 195) / 2) + 'px', 'width': (13 * bgSize.width / 20 - 281) + 'px'}" />
              </el-col>
              <el-col style="width: 33%;height: 100%;text-align: left;margin-left: 2%;">
                <el-row style="width: 100%;height: 84px;line-height: 84px;font-size: 20px;">
                  合计(kW)：
                  <span style="font-size: 32px;">{{dataSum}}</span>
                </el-row>
                <el-row style="width: 100%;height: 48px;line-height: 48px;font-size: 14px;">
                  请确保参与需求侧响应的负荷为非重要负荷， 以免造成不必要的损失！
                </el-row>
              </el-col>
            </el-col>
          </el-row>
          <el-row style="height: 1px;width: 100%;background-color: #FFF" />
          <el-row style="height: calc(50% - 1px);width: 100%;" class="table">
            <el-row style="background-color: rgba(2, 124, 247, 0.8);width: 100%; height: 48px;">
              <span style="text-align: left;height: 48px;line-height: 48px;margin-left: 24px;color: rgb(247, 247, 247);display: flex;">预计经济效益</span>
            </el-row>
            <el-row style="height: calc(100% - 48px);width: 99%;text-align: left;margin-left: 1%;font-size: 14px;">
              <el-row v-if="priceFlag === 1" style="height: 48px;line-height: 48px;margin-top: 8px;">
                预计每次参与需求侧响应的收益为：
                <span>{{minPrice}} ~ {{maxPrice}} 元</span>
              </el-row>
              <el-row v-if="priceFlag === 1" style="height: 32px;line-height: 32px;font-size: 14px;">
                <el-row>实际金额以电网结算为准，具体参与要求及效果评估办法，请参考地方相关通知！</el-row>
                <el-row>
                  <a href="https://shoudian.bjx.com.cn/html/20210622/1159658.shtml" target="_blank">湖北：https://shoudian.bjx.com.cn/html/20210622/1159658.shtml</a>
                </el-row>
              </el-row>
              <el-row v-else-if="priceFlag === 0" style="height: 64px;line-height: 64px;">
                所选站点还未设置需求测响应相应参数，快去系统设置-需求侧响应设置模块中设置吧！
              </el-row>
            </el-row>
          </el-row>
        </el-row>
        <el-row v-else style="width: 100%; height: 100%;font-size: 24px;display: flex;align-items: center;justify-content: center;">
          <span>请选择参与需求侧响应的监测点，然后点击“开始分析”按钮！</span>
        </el-row>
      </el-main>
    </el-row>
  </el-container>
</template>

<script>
import DateUtils from "../../../utils/DateUtils";
import CommonCharts from "../../common/chart/CommonCharts";
import buildCommonConfig from "../../../config/chart/config_common_line";
import {Message} from "element-ui";
export default {
  name: "DemandAnalyse",
  components: {CommonCharts},
  data() {
    return {
      radio: '月',
      initOptions: {
        renderer: 'canvas'
      },
      initOptions1: {
        renderer: 'canvas'
      },
      timestamp: 0,
      chartData: {},
      circleData: {},
      lineData: {},
      selNode: '',
      treeData: [],
      expandKeys: [],
      defaultProps: {
        children: 'childNode',
        label: 'name'
      },
      type: 'month',
      dateType: 2,
      startDate: DateUtils.getYesterday().Format('yyyy-MM'),
      monthDate: new Date().Format('yyyy-MM'),
      format: 'yyyy-MM',
      bgSize: {'width': window.innerWidth, 'height': window.innerHeight},
      filterName: '',
      tableData: [],
      checkedKey: '',
      curveData: {},
      isShow: false,
      dataSum: '',
      minPrice: '',
      maxPrice: '',
      priceFlag: -1
    }
  },
  created() {
    this.getTree('1')
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.bgSize.width = window.innerWidth
      this.bgSize.height = window.innerHeight
      this.timestamp = new Date().getTime()
    })
  },
  watch: {
    filterName(val) {
      this.$refs.tree.filter(val);
    }
  },
  methods: {
    getTree(val) {
      this.$api.systemManage.getSensorTree(val).then(res => {
        this.treeData = res.data
        if (this.treeData && this.treeData.length > 0) {
          this.selNode = this.getLeafNode(this.treeData[0]);
          let nodeIdName = 'id';
          this.$nextTick(function () {
            this.setTreeCurrent(this.selNode[nodeIdName], 1);
          })
        }
      })
    },
    getLeafNode(pNode) {
      let leafNode = pNode;
      if (pNode.childNode && pNode.childNode.length > 0) {
        leafNode = this.getLeafNode(pNode.childNode[0]);
      }
      return leafNode;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data['name'].indexOf(value) !== -1;
    },
    setTreeCurrent(key, time) {
      if (time > 10) throw new Error('没有找到 树组件');
      let tree = this.$refs.tree;
      if (tree) {
        tree.setCurrentKey(key);
        this.expandKeys.push(key);
        let node = tree.getNode(key);
        if (key !== -1) tree.$emit("node-click", node.data, node, tree);
      } else {
        this.setTreeCurrent(key, time + 1)
      }
    },
    getChartData() {
      this.isShow = false
      this.priceFlag = -1
      this.curveData = {}
      if (this.$refs.tree.getCheckedKeys().length === 0) {
        Message.warning('请先选择监测点再进行分析！')
        return
      }
      let params = {'id': this.$refs.tree.getCheckedKeys().join(",")}
      this.$api.energyAnalyse.getDemandAnalyse(params).then(res => {
        this.isShow = true
        let xAxis = res.data.curveMap.dataName
        let legend = ['平均功率']
        let data = [{
          name: res.data.curveMap.dataName,
          type: 'bar',
          barMaxWidth: 40,
          data: res.data.curveMap.dataData.split(",")
        }]
        this.curveData = buildCommonConfig(legend, xAxis, data, 0, 'kW')
        this.dataSum = res.data.dataSum
        this.priceFlag = res.data.priceFlag
        if (res.data.priceFlag === 1) {
          this.minPrice = res.data.minPrice
          this.maxPrice = res.data.maxPrice
        }
        this.timestamp = new Date().getTime()
      })
    }
  }
}
</script>

<style scoped>
  .doc-tree-top{
    display: inline-flex;
    align-items: center;
    height: 49px;
    width: 250px;
    border-bottom: 1px solid #fff;
  }
  .electric-parameter-charts{
    width: 100%;
    margin-top: 0;
  }
  .new-electric-parameter-charts{
    width: 100%;
    padding: 0;
  }
  /*.table /deep/ .el-table tr {*/
  /*  background-color: transparent!important;*/
  /*}*/
  .table /deep/ .el-table th {
    background-color: rgba(2, 124, 247, 0.2);
    border-top: 0;
  }
  /*.table /deep/ .el-table--enable-row-transition .el-table__body td, .el-table .cell{*/
  /*  background-color: transparent;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/EnergyAnalyse/DemandAnalyse.vue